@import "~@govbr-ds/core/src/components/switch/switch";

:host {
  display: inline-block;
}

:host([disabled]) .br-switch,
:host([disabled]) .br-switch label,
:host([disabled]) .br-switch input {
  cursor: not-allowed;
}
